import { Widget } from "./components/Widget"
import { CONFIG } from "./config"
import "./style.css"

const root = document.getElementById(CONFIG.WIDGET_CONTAINER_ID)
if (!root) {
  console.error(
    new Error(
      "TFG Root is missing. Please add a <div id='tfg-widget'></div> to your page."
    )
  )
} else {
  const widget = new Widget(root)
  widget.initialize()
}
